import type { TransactionExportBundle } from "./fetchTransactionExportBundle";

const TYPE_SLUG: Record<TransactionExportBundle["meta"]["type"], string> = {
  orders: "orders",
  payouts: "payouts",
  giftcard: "giftcards",
  billpayment: "bill-payments",
  otc: "otc-desk",
  spread: "fees",
  businesses: "merchants",
};

/** Lowercase hyphenated slug for path segments. */
function slugify(s: string, maxLen: number): string {
  const t = String(s ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, maxLen);
  return t;
}

/**
 * Readable basename (no extension) for admin transaction CSV/PDF exports.
 * Example: `DeexAdmin-transactions-orders-20250101-20250430-giftcards-only`
 */
export function buildAdminExportFileBasename(
  bundle: TransactionExportBundle,
  reportTitle: string
): string {
  const typeSlug = TYPE_SLUG[bundle.meta.type];
  const fromC = bundle.meta.startDate.replace(/-/g, "");
  const toC = bundle.meta.endDate.replace(/-/g, "");
  const parts = ["DeexAdmin", "transactions", typeSlug];

  const titleSlug = slugify(reportTitle, 36);
  if (titleSlug && titleSlug !== typeSlug && !titleSlug.startsWith(`${typeSlug}-`)) {
    parts.push(titleSlug);
  }

  parts.push(`${fromC}-${toC}`);

  if (bundle.meta.orderSubtype && bundle.meta.orderSubtype !== "all") {
    parts.push(slugify(String(bundle.meta.orderSubtype), 28));
  }
  if (bundle.meta.billSubtypes) {
    parts.push(slugify(bundle.meta.billSubtypes.replace(/\s*,\s*/g, "-"), 32));
  }
  if (bundle.meta.otcSubtypes) {
    parts.push(slugify(bundle.meta.otcSubtypes.replace(/\s*,\s*/g, "-"), 32));
  }
  if (bundle.meta.businessTxType) {
    parts.push(slugify(bundle.meta.businessTxType, 16));
  }
  if (bundle.meta.businessStatus) {
    parts.push(slugify(bundle.meta.businessStatus, 16));
  }

  return parts.join("-");
}
